import { ReactNode } from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  SvgIcon,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

type FilterBaseProps = {
  children: ReactNode;
  label: string;
  index: number;
  subHeading: string | null;
  defaultExpanded: boolean;
};

export const FilterBase = ({
  children,
  label,
  index,
  subHeading,
  defaultExpanded,
}: FilterBaseProps) => {
  const classes = useStyles();
  return (
    <Accordion
      classes={{ expanded: classes.expanded }}
      defaultExpanded={defaultExpanded}
      TransitionProps={{
        unmountOnExit: true,
      }}
    >
      <AccordionSummary
        id={`panel${index}a-header`}
        aria-controls={`panel${index}a-content`}
        expandIcon={<SvgIcon component={ExpandMoreIcon} />}
        classes={{
          expandIcon: classes.expandIcon,
          root: classes.accordionSummaryRoot,
          content: classes.accordionContent,
        }}
      >
        <div className={classes.headingContainer}>
          <Typography className={classes.heading}>{label}</Typography>
          <Typography className={classes.subheading}>{subHeading}</Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails
        classes={{
          root: classes.accordionDetailsRoot,
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: 16,
      fontWeight: theme.typography.fontWeightRegular,
      color: theme.palette.dark.main,
      flex: 1,
    },
    accordionSummaryRoot: {
      paddingTop: theme.spacing(2),
      paddingLeft: theme.spacing(2.25),
      paddingBottom: theme.spacing(2),
      paddingRight: theme.spacing(2),
      minHeight: "auto !important",
    },
    accordionDetailsRoot: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      overflowX: "auto",
    },
    accordionContent: {
      margin: "0 !important",
    },
    expandIcon: {
      padding: 0,
      margin: 0,
      color: theme.palette.primary.main,
      "& svg": {
        fontSize: 24,
      },
    },
    expanded: {
      margin: "0!important",
      "&::before": {
        opacity: "1!important",
        display: "block",
      },
      "&.MuiAccordion-root.Mui-expanded + .MuiAccordion-root::before": {
        display: "block",
      },
    },
    headingContainer: {
      flex: 1,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    subheading: {
      flex: 2,
      color: theme.palette.battleshipGrey.main,
      fontSize: 14,
      lineHeight: 1.36,
      marginRight: theme.spacing(2),
      textAlign: "right",
    },
  }),
);
